<template>
  <div class="company-info">
    <div class="mod-title" v-if="showTitle">
      <span class="main">企业文化</span><span class="en">company</span>
    </div>
    <div class="info-box">
      <div class="left">
        <!--        <div class="base-info">-->
        <!--          <div class="base-box">-->
        <!--            <div class="num">{{info.peopleNum}}<span class="unit">人</span></div>-->
        <!--            <div class="type">公司员工</div>-->
        <!--          </div>-->
        <!--          <div class="base-box">-->
        <!--            <div class="num">{{info.projectNum}}<span class="unit">个</span></div>-->
        <!--            <div class="type">项目数量</div>-->
        <!--          </div>-->
        <!--          <div class="base-box">-->
        <!--            <div class="num">{{info.money}}<span class="unit">万元</span></div>-->
        <!--            <div class="type">项目金额</div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="w-e-text-container">
          <div class="content-box" v-html="info.content" data-slate-editor></div>
        </div>
      </div>
      <div class="right" v-if="showRight">
        <div class="contact-box">
          <div class="title">
            <span class="icon icon-phone icon-mid"></span>
            <span>联系方式</span>
          </div>
          <ul>
            <li>{{ companyInfo.fullName }}</li>
            <li><span class="icon icon-location icon-mini"></span>地址：{{ contact.addr }}</li>
            <li><span class="icon icon-info icon-mini"></span>邮编：{{ contact.post }}</li>
            <li><span class="icon icon-phone01 icon-mini"></span>电话：{{ contact.workPhone }}</li>
            <li><span class="icon icon-location icon-mini"></span>传真：{{ contact.fax }}</li>
            <li><span class="icon icon-info icon-mini"></span>邮箱：{{ contact.mail }}</li>
            <li><span class="icon icon-info icon-mini"></span>商务洽谈：{{ contact.business }}</li>
          </ul>
        </div>
      </div>
      <div class="work-pic-list">
        <div class="mod-title">
          <span class="main">办公实况</span><span class="en">work office</span>
        </div>
        <div v-if="tempArray.length > 1">
          <vue-seamless-scroll ref="seamlessScroll" :data="tempArray"
                               class="seamless-warp"
                               :class-option="defaultOption">
            <ul class="ul-scoll">
              <li class="img-box" v-for="(item, index) in tempArray" :key='index'>
                <img :src="item.url">
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get} from '@/util/Http';
import {INFO} from '@/util/const';
import vueSeamlessScroll from 'vue-seamless-scroll';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    vueSeamlessScroll,
  },
  name: 'CompanyInfo',
  props: ['showRight', 'showTitle'],
  data() {
    return {
      defaultOption: {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        autoPlay: false,
      },
      tempArray: [],
      companyInfo: INFO,
      info: {
        money: 0,
        peopleNum: 0,
        projectNum: 0,
        content: '',
      },
      contact: {
        addr: '',
        post: '',
        workPhone: '',
        fax: '',
        mail: '',
        business: '',
      },
    };
  },
  created() {
    this.getCompanyInfo();
    this.getCompanyContact();
  },
  mounted() {
    setTimeout(() => {
      this.defaultOption.autoPlay = true;
      if (this.$refs.seamlessScroll) {
        this.$refs.seamlessScroll.reset();
      }

    }, 4000);
  },
  methods: {
    getCompanyInfo() {
      get('/getCompanyInfo')
        .then((result) => {
          if (result.status === 200) {
            this.info = result.data.info;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCompanyContact() {
      get('/getCompanyContact')
        .then((result) => {
          if (result.status === 200) {
            this.contact = result.data.contact;
            this.tempArray = JSON.parse(this.contact.img || '[]');
          }
        }).catch((error) => {
        console.log(error);
      });
    },
  },
};
</script>

<style lang="less">
.work-pic-list {
  overflow: hidden;

  .ul-scoll {
    overflow: hidden;
    display: flex;

    .img-box {
      display: inline-block;
      flex-shrink: 0;
      box-sizing: border-box;
      padding: 0 5px;

      img {
        width: 100%;
        height: 400px;;
        overflow: hidden;
        border-radius: 4px;
      }
    }
  }
}

.seamless-warp {
  height: 400px;
  border-radius: 4px;
  overflow: hidden;

  > div {
    width: 99999px !important;
  }
}

.contact-box {
  z-index: 2;
}

</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
